export default __webpack_public_path__ + "static/media/Red0007.f1412ce2.png";